﻿import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../../lib-shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';


@Injectable()
export class StatementsService extends BaseService {

    constructor(http: HttpClient, injector: Injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/Statements`);
    }

    Gets(key: string, dealType: number, userId: number, status: number, fromDate: Date, toDate: Date, offset?: number, limit?: number, sortField?: string, isAsc: boolean = false) {
        let fDate = undefined;
        if (fromDate)
            fDate = fromDate.toISOString();
        let tDate = undefined;
        if (toDate)
            tDate = toDate.toISOString();
        const queryString = `${this.serviceUri}?key=${key}&dealType=${dealType}&userId=${userId}&status=${status}&fromDate=${fDate}&toDate=${tDate}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }

    GetsCurrentUser(key: string, dealType: number, status: number, fromDate: Date, toDate: Date, offset?: number, limit?: number, sortField?: string, isAsc: boolean = false) {
        let fDate = undefined;
        if (fromDate)
            fDate = fromDate.toISOString();
        let tDate = undefined;
        if (toDate)
            tDate = toDate.toISOString();
        const queryString = `${this.serviceUri}/GetsCurrentUser?key=${key}&dealType=${dealType}&status=${status}&fromDate=${fDate}&toDate=${tDate}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }

    GetBalance() {
        const queryString = `${this.serviceUri}/GetBalance`;
        return this.defaultGet(queryString);
    }
    GetBalanceCSKH(fromDate: Date, toDate: Date, type: number) {
        let fDate;
        if (fromDate) {
            fDate = fromDate.toISOString();
        }
        let tDate;
        if (toDate) {
            tDate = toDate.toISOString();
        }
        const queryString = `${this.serviceUri}/GetBalanceCSKH?fromDate=${fDate}&toDate=${tDate}&type=${type}`;
        return this.defaultGet(queryString);
    }

    GetBalanceDN(fromDate: Date, toDate: Date, type: number) {
        let fDate;
        if (fromDate) {
            fDate = fromDate.toISOString();
        }
        let tDate;
        if (toDate) {
            tDate = toDate.toISOString();
        }
        const queryString = `${this.serviceUri}/GetBalanceDN?fromDate=${fDate}&toDate=${tDate}&type=${type}`;
        return this.defaultGet(queryString);
    }

    GetBalanceNCC(fromDate: Date, toDate: Date, type: number) {
        let fDate;
        if (fromDate) {
            fDate = fromDate.toISOString();
        }
        let tDate;
        if (toDate) {
            tDate = toDate.toISOString();
        }
        const queryString = `${this.serviceUri}/GetBalanceNCC?fromDate=${fDate}&toDate=${tDate}&type=${type}`;
        return this.defaultGet(queryString);
    }

    TopProductsNCC(fromDate: Date, toDate: Date, type: number) {
        let fDate;
        if (fromDate) {
            fDate = fromDate.toISOString();
        }
        let tDate;
        if (toDate) {
            tDate = toDate.toISOString();
        }
        const queryString = `${this.serviceUri}/TopProductByNCC?fromDate=${fDate}&toDate=${tDate}&type=${type}`;
        return this.defaultGet(queryString);
    }

    ThongKeDNTheoTrangThai(fromDate: Date, toDate: Date, type: number) {
        let fDate;
        if (fromDate) {
            fDate = fromDate.toISOString();
        }
        let tDate;
        if (toDate) {
            tDate = toDate.toISOString();
        }
        const queryString = `${this.serviceUri}/ThongKeDNTheoTrangThai?fromDate=${fDate}&toDate=${tDate}&type=${type}`;
        return this.defaultGet(queryString);
    }

    ThongKeDNTheoTrangThaiFull(key: string, idShop: number, idProvince: number, idDistrict: number, dateType: number, ctv: string, idProduct: number, shipStatus: any, isShip: number, status: any, actions: any, fromDate: any, toDate: any, dayNumber: number, paymentChannel: number, idUserKol: number, orderType: number, isPreOrder: number) {
        let fDate;
        if (fromDate) {
            fDate = fromDate.toISOString();
        }
        let tDate;
        if (toDate) {
            tDate = toDate.toISOString();
        }
        const queryString = `${this.serviceUri}/ThongKeDNTheoTrangThai?key=${key}&idShop=${idShop}&idProvince=${idProvince}&idDistrict=${idDistrict}&dateType=${dateType}&ctv=${ctv}&idProduct=${idProduct}&shipStatus=${shipStatus}&isShip=${isShip}&status=${status}&actions=${actions}&fromDate=${fDate}&toDate=${tDate}&dayNumber=${dayNumber}&paymentChannel=${paymentChannel}&idUserKol=${idUserKol}&orderType=${orderType}&isPreOrder=${isPreOrder}`;
        return this.defaultGet(queryString);
    }

    Withdraw(deal: number) {
        const queryString = `${this.serviceUri}/Withdraw/${deal}`;
        return this.defaultPost(queryString, {});
    }
    CancelWithdraw(id: number) {
        const queryString = `${this.serviceUri}/CancelWithdraw/${id}`;
        return this.defaultPost(queryString, {});
    }
    Process(item: any) {
        const queryString = `${this.serviceUri}/Process`;
        return this.defaultPost(queryString, item);
    }
    Transfer(item: any, type: number) {
        const queryString = `${this.serviceUri}/Transfer?type=${type}`;
        return this.defaultPost(queryString, item);
    }
}

